<template>
  <div class="d-flex flex-row">
    <v-menu>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mx-2" icon v-bind="attrs" v-on="on">
          <v-icon>mdi-translate</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          @click="switchLocale(locale.code)"
          v-for="locale in locales"
          :key="locale.title"
        >
          <v-list-item-title>{{ locale.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-menu offset-y bottom>
      <template v-slot:activator="{ on }">
        <div
          class="grey lighten-1 d-flex flex-column justify-center pl-8 pr-2"
          style="border-radius: 24px 0 0 24px; height: 48px"
        >
          <v-btn class="text-none" text v-on="on">
            <v-avatar right size="36" class="mr-3">
              <img :src="profilePicUrl" alt="avatar" />
            </v-avatar>
            {{ user.name }}
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </div>
      </template>

      <v-list>
        <v-list-item @click="editProfile">
          <v-list-item-title>{{ $t("navbar.edit_profile") }}</v-list-item-title>
        </v-list-item>
        <!-- <v-list-item :to="{ name: 'payment_settings' }">
          <v-list-item-title>{{ $t("routes.payment_settings") }}</v-list-item-title>
        </v-list-item> -->
        <v-list-item @click="logout">
          <v-list-item-title>{{ $t("navbar.logout") }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import firebase from "@/firebase/login";

const languageNames = {
  en: { name: "English", short: "En" },
  ja: { name: "日本語", short: "Ja" },
  es: { name: "Español", short: "Es" },
};

export default {
  props: ["user"],

  data() {
    return {
      // showAbbr: true,
      locale: localStorage.getItem("languageSelect") || "en",
      locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(",").map((code) => ({
        code,
        title: languageNames[code].name,
        abbr: languageNames[code].short,
      })),
    };
  },

  computed: {
    profilePicUrl() {
      const { firUser } = this.$store.state;
      if (firUser) {
        return (
          this.$store.state.imageUrls[firUser.uid] || require("@/assets/profile_pic_empty.png")
        );
      }
      return require("@/assets/profile_pic_empty.png");
    },
  },
  methods: {
    switchLocale(locale) {
      // this.$root.$emit("updateNavI", "locale")
      // console.log("Cambio a: " + locale)
      console.log("Borrando");
      localStorage.removeItem("languageSelect");

      console.log("Cambiando");
      this.$i18n.locale = locale;
      localStorage.setItem("languageSelect", locale);
      console.log("Actual");
      console.log(localStorage.getItem("languageSelect"));
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    },

    logout() {
      firebase.logout();
    },
    editProfile() {
      console.log("editProfile");
      this.$router.push({ name: "user_profile" });
    },
  },
};
</script>
